import { Box } from '@mui/material';
import { TattooChoices } from '@prisma/client';
import { Appointment, GeneralRequest, ModalData } from '../../interfaces';
import RequestCard from './RequestCard';

interface Props {
  appointments: (Appointment | GeneralRequest)[];
  handleClick: (
    newModalData: ModalData,
    appointment: Appointment | GeneralRequest,
  ) => void;
  sizeOptions: TattooChoices[] | undefined;
  unreadRequests?: {
    generalRequests: string[];
    appointments: string[];
  };
}

export default function HorizontalCardList({
  appointments,
  handleClick,
  sizeOptions,
  unreadRequests,
}: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        overflow: 'auto',
        // give space for badge in RequestCard
        paddingTop: '5px',
        paddingLeft: '5px',
      }}>
      {appointments.map(appointment => {
        const isUnread =
          'appointmentId' in appointment
            ? unreadRequests?.appointments.includes(appointment.appointmentId)
            : unreadRequests?.generalRequests.includes(appointment.requestId);
        return (
          <RequestCard
            key={
              'appointmentId' in appointment
                ? appointment.appointmentId
                : appointment.requestId
            }
            appointment={appointment}
            handleClick={handleClick}
            sizeOptions={sizeOptions}
            isUnread={!!isUnread}
          />
        );
      })}
    </Box>
  );
}
